import axios from "axios";
import { getCookie } from "../config/varConfig"; // same token as AstroDhyaan

const JKM_BASE =
  import.meta.env.DEV ? "/jkm-api" : "https://www.jkmdocumentation.com";

export const JKM_API_URL = `${JKM_BASE}/api/admin`;

export const jkmApi = axios.create({
  baseURL: JKM_API_URL,
  withCredentials: false,
});

// Attach the same AstroDhyaan Bearer token to every JKM request
jkmApi.interceptors.request.use(
  (config) => {
    const token = getCookie("token"); // reuse AstroDhyaan token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const getJkmQueries = async (params = {}) => {
  const response = await jkmApi.get("/query", { params });
  return response.data;
};

export const updateJkmQuery = async (id, queryData) => {
  const response = await jkmApi.put(`/query/${id}`, queryData);
  return response.data;
};